import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Collapse,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
const GenericErrorModal = (
  {
    children,
    title,
    error,
    errorReset,
    rawError,
    secondaryAction,
    primaryAction,
    skipDispatch,
  },
  context
) => {
  const dispatch = useDispatch();
  const [showFullError, setShowFullError] = useState(false);
  const toggle = () => setShowFullError(!showFullError);
  return (
    <Modal
      isOpen={error ? true : false}
      toggle={() =>
        errorReset
          ? skipDispatch
            ? errorReset()
            : dispatch(errorReset())
          : null
      }
    >
      <ModalHeader
        toggle={() =>
          errorReset
            ? skipDispatch
              ? errorReset()
              : dispatch(errorReset())
            : null
        }
      >
        <span className="text-danger">
          {title || context.t("An Error occured!")}
        </span>
      </ModalHeader>
      <ModalBody>
        {children}
        {rawError && (
          <>
            <span
              className="text-danger small cursor-pointer"
              onClick={toggle}
              style={{ marginBottom: "1rem" }}
            >
              {context.t("show full error message")}{" "}
              {!showFullError && <FaCaretDown />}{" "}
              {showFullError && <FaCaretUp />}
            </span>
            <Collapse isOpen={showFullError}>
              <pre className="text-wrap text-break">{rawError}</pre>
            </Collapse>
          </>
        )}
      </ModalBody>
      {(primaryAction || secondaryAction) && (
        <ModalFooter>
          {secondaryAction && (
            <Button
              color="primary"
              outline
              onClick={() =>
                secondaryAction
                  ? skipDispatch
                    ? secondaryAction?.action()
                    : dispatch(secondaryAction?.action())
                  : null
              }
            >
              {secondaryAction?.title}
            </Button>
          )}
          {primaryAction && (
            <Button
              color="primary"
              onClick={() =>
                primaryAction
                  ? skipDispatch
                    ? primaryAction?.action()
                    : dispatch(primaryAction?.action())
                  : null
              }
            >
              {primaryAction?.title}
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

GenericErrorModal.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorReset: PropTypes.func,
  children: PropTypes.any,
  rawError: PropTypes.string,
  title: PropTypes.string,
  primaryAction: PropTypes.any,
  secondaryAction: PropTypes.any,
  skipDispatch: PropTypes.bool,
};

GenericErrorModal.defaultProps = {};
GenericErrorModal.contextTypes = {
  t: PropTypes.func,
};

export default GenericErrorModal;
